import React, { useEffect, useRef, useState, useMemo } from "react";
import { ID_TAB_EVENT_2024, ROUTER_EVENT_2024 } from "@config/constants/helper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { PATHS } from "@config/constants";
import { useTranslation } from "react-i18next";

const Header = ({ idTab, statusEvent = {} }) => {
  const [isEnd, setIsEnd] = useState(false);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 567);
  const swiperRef = useRef(null);
  const history = useHistory();
  const { t } = useTranslation();

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 567);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const postionItemMenuActive = useMemo(() => {
    let postionItemActive = 0;

    ROUTER_EVENT_2024.forEach((item, index) => {
      if (item.id === idTab) {
        postionItemActive = index;
      }
    });

    return postionItemActive;
  }, [idTab]);

  const handleNext = () => {
    swiperRef.current.swiper.slideNext();
  };

  const handlePrev = () => {
    swiperRef.current.swiper.slidePrev();
  };

  const handleSlideChange = (swiper) => {
    setIsEnd(swiper.isEnd);
    setIsBeginning(swiper.isBeginning);
  };

  const handChangeTab = (id) => {
    history.push(`${PATHS.EVENT}/${id}`);
  };

  return (
    <div id="header-event">
      <div className="header-pc-event">
        <div className={`header-event-container ${+statusEvent.is_finished !== 0 ? "header-event-container-grid-3" : ""}`}>
          {ROUTER_EVENT_2024.map((item) => {
            if (
              (+statusEvent.is_finished === 0 &&
                item.id === ID_TAB_EVENT_2024.congratulation) ||
              (+statusEvent.is_finished !== 0 &&
                (item.id === ID_TAB_EVENT_2024.navidadExplosive ||
                  item.id === ID_TAB_EVENT_2024.christmasTree))
            ) {
              return null;
            }
            return (
              <div
                key={item.id}
                className={`header-event_item ${
                  item.id === idTab ? "header-evernt_item__active" : ""
                }`}
                onClick={() => handChangeTab(item.id)}
              >
                {t(`event_2024.${item.id}.title`)}
              </div>
            );
          })}
        </div>
      </div>
      {/* mobile */}
      <div className="header-mobile-event position-relative">
        <Swiper
          ref={swiperRef}
          slidesPerView={isSmallScreen ? 1.5 : 2.25} // Hiển thị total slide mỗi lần
          spaceBetween={0} // Khoảng cách giữa các slide
          speed={500} // Tốc độ chuyển slide
          freeMode={true} // Cho phép trượt tự do theo lực vuốt
          freeModeMomentum={true} // Đà vuốt, giúp cảm giác mượt mà
          pagination={{ clickable: false }} // Chấm điều hướng
          onSlideChange={handleSlideChange}
          initialSlide={postionItemMenuActive}
        >
          {ROUTER_EVENT_2024.map((item) => {
            if (
              (+statusEvent.is_finished === 0 &&
                item.id === ID_TAB_EVENT_2024.congratulation) ||
              (+statusEvent.is_finished !== 0 &&
                (item.id === ID_TAB_EVENT_2024.navidadExplosive ||
                  item.id === ID_TAB_EVENT_2024.christmasTree))
            ) {
              return null;
            }
            return (
              <SwiperSlide key={item.id}>
                <div
                  className={`header-event_item ${
                    item.id === idTab ? "header-evernt_item__active" : ""
                  }`}
                  onClick={() => handChangeTab(item.id)}
                >
                  {t(`event_2024.${item.id}.title`)}
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
        {!isBeginning ? (
          <button
            onClick={handlePrev}
            className="btn-custom-event custom-prev-event"
          >
            <LeftOutlined />
          </button>
        ) : null}
        {!isEnd ? (
          <button
            onClick={handleNext}
            className="btn-custom-event custom-next-event"
          >
            <RightOutlined />
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default Header;
